/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTableSection_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"InvoiceFilterButton_viewer">;
    readonly " $refType": "ProjectInvoicingTableSection_viewer";
};
export type ProjectInvoicingTableSection_viewer$data = ProjectInvoicingTableSection_viewer;
export type ProjectInvoicingTableSection_viewer$key = {
    readonly " $data"?: ProjectInvoicingTableSection_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectInvoicingTableSection_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTableSection_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InvoiceFilterButton_viewer"
    }
  ],
  "type": "Viewer"
};
(node as any).hash = '16c70b4d8388537ee07f5990b272d857';
export default node;
